import Script from "next/script"
import { useEffect, useRef, useState } from "react"
import styled from "styled-components"

const STORYLY_TOKEN = process?.env?.STORYLY_TOKEN

declare global {
  namespace JSX {
    interface IntrinsicElements {
      "storyly-web": React.DetailedHTMLProps<
        React.HTMLAttributes<HTMLElement>,
        HTMLElement
      >
    }
  }
}

const StyledStorylyContainer = styled.div`
  margin: 28px 0;
  min-height: 114px;
  ${(p) => p.theme.breakpoints.up("md")} {
    margin: 44px 0;
  }
`

const Storyly = () => {
  const storylyRef = useRef(null)
  const [loaded, setLoaded] = useState(false)

  useEffect(() => {
    // Initialize Storyly
    typeof storylyRef?.current?.init === "function" &&
      storylyRef?.current?.init({
        token: STORYLY_TOKEN,
        props: {
          storyGroupTextSize: "20",
          storyGroupTextFont: "Speedee, NarkisBlock",
          storyGroupTextWeight: "normal",
          storyTextFont: "Speedee, NarkisBlock",
        },
        barLayout: {
          dir: "rtl",
        },
      })
  }, [loaded])

  const handleOnload = () => {
    setLoaded(true)
  }

  if (!STORYLY_TOKEN) {
    return null
  }

  return (
    <>
      {STORYLY_TOKEN && (
        <>
          <Script
            data-custom-element="storyly-web"
            src="https://web-story.storyly.io/v2/storyly-web.js"
            async
            onLoad={handleOnload}
          ></Script>

          <StyledStorylyContainer dir="rtl">
            <storyly-web ref={storylyRef} dir="rtl" />
          </StyledStorylyContainer>
        </>
      )}
    </>
  )
}

export default Storyly
